import { number } from 'yup'
import { safify } from '../utils/safify'

export const count = number().default(3).meta({ autoFill: true }).transform(safify)
